// v2: objetos anidados
export const darkThemeV2 = {
  common: {
    backgroundColor: '#121212',
    gridSelection: { backgroundColor: 'rgba(255,255,255,0.06)' },
    dayName: { color: '#ccc' },            // textos cabecera
    saturday: { color: '#bbb' },
    today: { color: '#ff9800' },
  },
  month: {
    dayName: {
      backgroundColor: '#1e1e1e',
      borderLeft: '1px solid #333',
      color: '#ddd',
    },
    moreView: {
      backgroundColor: '#1e1e1e',
      boxShadow: '0 2px 6px rgba(0,0,0,0.5)',
    },
  },
  calendars: [
    {
      id: '1', // ID para eventos 'abiertos'
      color: '#ffffff',
      backgroundColor: '#40a83b',
      borderColor: '#1e853f'
    },
    {
      id: '2', // ID para eventos 'vencidos'
      color: '#ffffff',
      backgroundColor: '#c94d4d',
      borderColor: '#782020'
    }
  ]
};

export const lightThemeV2 = {
  common: {
    backgroundColor: '#ffffff',
    gridSelection: { backgroundColor: 'rgba(33,150,243,0.12)' },
    dayName: { color: '#666' },
    saturday: { color: '#333' },
    today: { color: '#2196f3' },
  },
  month: {
    dayName: {
      backgroundColor: '#f5f5f5',
      borderLeft: '1px solid #e5e5e5',
      color: '#444',
    },
    moreView: {
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    },
  },
  calendars: [
    {
      id: '1', // ID para eventos 'abiertos'
      color: '#ffffff',
      backgroundColor: '#40a83b',
      borderColor: '#1e853f'
    },
    {
      id: '2', // ID para eventos 'vencidos'
      color: '#ffffff',
      backgroundColor: '#c94d4d',
      borderColor: '#782020'
    }
  ]
};
